/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Health_UnhealthyInputs */



/**
* | output |
* | --- |
* | "Unhealthy" |
*
* @param {Private_Models_Health_UnhealthyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_health_unhealthy = /** @type {((inputs?: Private_Models_Health_UnhealthyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Health_UnhealthyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht erreichbar")
	return /** @type {LocalizedString} */ ("Unhealthy")
});